import * as Either from 'fp-ts/Either';
import { isUnknown } from './ErrorAsync';
import { backOff } from './Maths';
/**
 * Returns a promise that resolves after the given amount of milliseconds.
 */
export const delay = (time) => new Promise((value) => {
    setTimeout(value, time);
});
/**
 * Wraps the given promise with a promise that only resolves or rejects if it was not cancelled.
 */
export const makeCancellable = (promise) => {
    let isCancelled = false;
    const wrappedPromise = new Promise((resolve, reject) => {
        promise
            .then((value) => !isCancelled && resolve(value))
            .catch((error) => !isCancelled && reject(error));
    });
    return {
        promise: wrappedPromise,
        cancel() {
            isCancelled = true;
        },
    };
};
const retryN = (count, fn, config) => {
    const { retries = 3, interval = 500, shouldRetry = isUnknown } = config || {};
    return fn().then(Either.fold((err) => {
        if (!shouldRetry(err) || retries === 1) {
            return Either.left(err);
        }
        return delay(backOff(count) * interval).then(() => retryN(count + 1, fn, {
            ...config,
            interval,
            retries: retries - 1,
        }));
    }, Either.right));
};
/**
 * Retries the given function if it fails for the given amount of times based on the given condition.
 * @deprecated in favour of useQuery
 */
export const retry = (fn, config) => retryN(1, fn, config);
